import { useContext, useState } from 'react'
import { MapContext, PlacesContext } from "../context";
import { LoadingPlaces } from './';
import { Feature } from '../interfaces/places';



export const SearchResults = () => {

    const {places, isLoadingPlaces, userLocation} = useContext(PlacesContext); 
    const {map, getRouteBetweenPoints} = useContext(MapContext); 

    const [activeID, setactiveID] = useState('');

    const onPlaceClicked = (place:Feature)=>{
        const [lng, lat] = place.center;
        setactiveID(place.id);
        map?.flyTo({
            zoom:14,
            center:[lng, lat],
        });
    }

    const getRoute=(place:Feature)=>{
        if(!userLocation)return;

        const [lng, lat] = place.center;
        getRouteBetweenPoints(userLocation, [lng, lat]);
    }

    if(isLoadingPlaces){
        return <LoadingPlaces/>
    }

    if(places.length === 0){
        //Remuevo ruta 
        if (map?.getLayer('RouteString')){
            map?.removeLayer('RouteString');
            map?.removeSource('RouteString');
        }
        return <></>;
    }

    return (
        <ul className="list-group mt-3">
        {
            places.map(place=>(
                <li 
                    key={place.id}
                    className={`list-group-item list-group-item-action pe-auto ${(activeID === place.id)? 'active':''}`}
                    onClick={()=>onPlaceClicked(place)}
                >
                <h6> {place.text_es}</h6>
                <p 
                    style={{
                        fontSize:'12px'
                    }}>
                    {place.place_name}
                </p>
                <button 
                    onClick={()=>getRoute(place)}
                    className={`btn btn-sm ${(activeID === place.id)?'btn-outline-light':'btn-outline-primary'}`}>Direcciones</button> 
            </li>
            ))
        }

        </ul>
    )
}
